import { Link } from 'react-router-dom'
import Header from './Header'
import './LandingPage.css'

const ServicesPage = () => {
  /* Services dropdown state and effects moved to Header component */

  return (
    <div className="landing-page">
      <Header />

      {/* Green Wavy Section */}
      <section className="services-green-section">
        <div className="services-green-wavy-top">
          {/* Wave 1 - Green (upward peaks) */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-1">
            <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
          </svg>
          {/* Wave 2 - White (downward peaks) */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-white">
            <path d="M0,50 Q60,80 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#ffffff" />
          </svg>
          {/* Wave 3 - Green (upward peaks) */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-2">
            <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
          </svg>
        </div>

        {/* How We Build Section */}
        <div className="services-how-we-build-content">
          <div className="services-how-we-build-text">
            <h2 className="services-how-we-build-headline">
              HOW WE BUILD FEARLESS BRANDS
            </h2>
            <p className="services-how-we-build-tagline">Let's talk strategy, story, and standout design — all tailored to you.</p>
          </div>
        </div>

        {/* Top 3 Service Cards - Overlapping */}
        <div className="services-top-cards-container">
          <div className="services-grid-container services-top-cards">
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/IMAGE-10.png" alt="Corporate Branding" loading="lazy" />
              </div>
              <div className="services-grid-label">CORPORATE BRANDING & DESIGN</div>
            </div>
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/IMAGE-11.png" alt="Brand Development" loading="lazy" />
              </div>
              <div className="services-grid-label">BRAND DEVELOPMENT & VISUAL IDENTITY</div>
            </div>
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/IMAGE-12.png" alt="Packaging Design" loading="lazy" />
              </div>
              <div className="services-grid-label">PACKAGING DESIGN</div>
            </div>
          </div>
        </div>

        <div className="services-green-wavy-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-white">
            <path d="M0,50 Q60,80 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#ffffff" />
            <path d="M0,50 Q60,80 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50" fill="none" stroke="#594F9A" strokeWidth="7" />
          </svg>
        </div>
      </section>

      {/* Services Grid Section - Bottom 3 Cards */}
      <section className="services-grid-section">
        {/* Bottom 3 Service Cards - Overlapping */}
        <div className="services-bottom-cards-container">
          <div className="services-grid-container services-bottom-cards">
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/Social media 2.png" alt="Social Media Management" loading="lazy" />
              </div>
              <div className="services-grid-label">SOCIAL MEDIA MANAGEMENT</div>
            </div>
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/DVC CONCEPT & STTORYBOARD 2.png" alt="DVC Concept & Storyboards" loading="lazy" />
              </div>
              <div className="services-grid-label">DVC CONCEPT & STORYBOARDS</div>
            </div>
            <div className="services-grid-card">
              <div className="services-grid-image">
                <img src="/packlaging.jpg" alt="PR and Trade Design Services" loading="lazy" />
              </div>
              <div className="services-grid-label">PR AND TRADE DESIGN SERVICES</div>
            </div>
          </div>
        </div>

        {/* Stop Blending In Section */}
        <div className="services-stop-blending-section">
          <div className="services-stop-blending-mouse">
            <img src="/icons BCS-21.svg" alt="Computer mouse" className="services-mouse-icon" />
          </div>
          <div className="services-stop-blending-content">
            <h2 className="services-stop-blending-headline">
              <span className="services-stop-blending-white">Stop blending in — start </span><span className="services-branding-text">branding out loud.</span>
            </h2>
            <p className="services-stop-blending-description">
              Whether you're launching, rebranding, or scaling your presence — let's build something unforgettable together.
            </p>
            <div className="services-stop-blending-process">
              From Idea → Identity → Impact
            </div>
            <Link to="/contact" className="services-stop-blending-button">ENQUIRE</Link>
          </div>
          <div className="services-stop-blending-handshake">
            <img src="/icons BCS-20.svg" alt="Handshake" className="services-handshake-icon" />
          </div>
        </div>
      </section>

      {/* White Section */}
      <section className="services-white-section">
      </section>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="footer-wavy-top">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-2">
            <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
          </svg>
        </div>
        <div className="footer-star-icon">
          <img src="/icons BCS-44.svg" alt="Star icon" className="footer-star-icon-img" />
        </div>
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/BCS%20LOGO-01%20(1).png" alt="BOLD! CREATIVE STUDIO" className="footer-logo-img" />
          </div>
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
              <img src="/WEBSITE IMAGES-17.svg" alt="Instagram" className="footer-social-icon-img" />
            </a>
            <a href="https://www.behance.net/brandingoutloud?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnHFYMm_3Cc_qOoIHo5M7pIpJVh1fw7yG_MjUWcetV-lC7sxbyqLSp49vJ22Y_aem_NaED6HYtWH8rqyuMagDYig" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Behance">
              <img src="/WEBSITE IMAGES-18.svg" alt="Behance" className="footer-social-icon-img" />
            </a>
            <a href="https://www.linkedin.com/company/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
              <div className="footer-social-icon-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#594F9A', borderRadius: '50%', transform: 'scale(0.75)' }}>
                <svg viewBox="0 0 24 24" fill="white" style={{ width: '24px', height: '24px', margin: 0 }}>
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </div>
            </a>
            <a href="https://www.facebook.com/share/1879QvWrk8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
              <img src="/WEBSITE IMAGES-19.svg" alt="Facebook" className="footer-social-icon-img" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default ServicesPage

